import { Column, ModelBase } from 'loca-boot-core'

export class ShareModelLink extends ModelBase {
  @Column({ name: 'related_link' })
  public link!: string
}

export class RouteCDNModel extends ModelBase {
  @Column()
  public chargingTripRouteLink!: string

  @Column()
  public swapResourcesLink!: string[]

  @Column()
  public chargeResourcesLink!: string[]

  // 三方资源
  @Column()
  public thirdResourcesLink!: string[]

  // 蔚来门店资源
  @Column()
  public nioStoreResourcesLink!: string[]

  // 试驾点资源
  @Column()
  public testDriveResourcesLink!: string[]

  // 服务中心资源
  @Column()
  public serviceCenterResourcesLink!: string[]

  // 心愿站资源
  @Column()
  public wishPowerLink!: string[]
}
